import { chineseToEnglish as chineseToEnglishFunc } from '@/utils/commonUtil'
import $store from '@/store'

// 中英文映射
const zhEnMap = new Map([
  ['资产', 'Assets'], ['行次', 'Sequence'], ['年初数', 'Beginning Balance'], ['期末数', 'Ending Balance'],
  ['负债和所有者(或股东)权益', 'Liabilities and owner\'s (or shareholder\'s) equity'], ['行次', 'Sequence'],
  ['年初数', 'Beginning Balance'], ['期末数', 'Ending Balance'],
  ['流动资产：', 'Current Assets: '], ['货币资金', 'Monetary funds'], ['短期投资', 'short-term investments'],
  ['应收票据', 'Notes receivable'], ['应收账款', 'Accounts receivable'], ['预付账款', 'Advanced payments'],
  ['应收股利', 'Dividends receivable'], ['应收利息', 'Interest receivable'], ['其他应收款', 'Other accounts receivable'],
  ['存货', 'Inventory'], ['其中：原材料', 'Raw materials'], ['在产品', 'Work in progress'],
  ['库存商品', 'Merchandise inventory'], ['周转材料', 'Working capital'], ['其他流动资产', 'Other current assets'],
  ['流动资产合计', 'Total current assets'], ['非流动资产：', 'Non-current assets:'], ['长期债券投资', 'Long-term bond investments'],
  ['长期股权投资', 'Long-term equity investments'], ['固定资产原价', 'Original value of fixed assets'],
  ['减：累计折旧', 'Less: accumulated depreciation'], ['固定资产账面价值', 'Net book value of fixed assets'],
  ['在建工程', 'Construction in progress'], ['工程物资', 'Engineering materials'], ['固定资产清理', 'Fixed asset clearance'],
  ['生产性生物资产', 'Productive biological assets'], ['无形资产', 'Intangible assets'], ['开发支出', 'Development costs'],
  ['长期待摊费用', 'Long-term prepayments'], ['其他非流动资产', 'Other non-current assets'], ['非流动资产合计', 'Total non-current assets'],
  ['资产总计', 'Total assets'], ['流动负债：', 'Current Liabilities:'], ['短期借款', 'short-term loans'], ['应付票据', 'Notes payable'],
  ['应付账款', 'Accounts payable'], ['预收账款', 'Advanced receipts'], ['应付职工薪酬', 'Employee benefits payable'],
  ['应交税费', 'Taxes and fees payable'], ['应付利息', 'Interest payable'], ['应付利润', 'Profits payable'],
  ['其他应付款', 'Other accounts payable'], ['其他流动负债', 'Other current liabilities'], ['流动负债合计：', 'Total current liabilities:'],
  ['非流动负债：', 'Non-current liabilities:'], ['长期借款', 'Long-term loans'], ['长期应付款', 'Long-term payables'],
  ['递延收益', 'Deferred income'], ['其他非流动负债', 'Other non-current liabilities'], ['非流动负债合计', 'Total non-current liabilities:'],
  ['负债合计', 'Total liabilities'], ['所有者权益（或股东权益）：', 'Paid-in capital (or share capital)'],
  ['实收资本（或股本）', 'Paid-in capital (or share capital)'], ['资本公积', 'Capital reserves'], ['盈余公积', 'surplus reserves'],
  ['未分配利润', 'Undistributed profits'], ['所有者权益（或股东权益）合计', 'Total owner\'s equity (or shareholder\'s equity)'],
  ['负债和所有者权益（或股东权益）总计', 'Total liabilities and owner\'s equity (or shareholder\'s equity)']
])

/**
 * 中文转英文
 * @param {Object} obj
 */
export function chineseToEnglish(obj) {
  if ($store.getters.language === 'zh') {
    return
  }
  chineseToEnglishFunc(obj, zhEnMap)
}
